import React, { useContext } from 'react';
import { shouldDisplayEmployerLogo } from '../helpers';
import { JobContext } from '../JobContext';
export var EmployerLogo = function EmployerLogo() {
  var _useContext = useContext(JobContext),
      prefix = _useContext.prefix,
      employer = _useContext.employer,
      cardStyle = _useContext.cardStyle,
      modulesV2 = _useContext.modulesV2,
      forceLogo = _useContext.forceLogo,
      logoWidth = _useContext.logoWidth,
      logoHeight = _useContext.logoHeight,
      useLogoPlaceholder = _useContext.useLogoPlaceholder;

  var renderPlaceholder = function renderPlaceholder() {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefix, "__logo ").concat(prefix, "__logo-placeholder"),
      role: "img",
      alt: "Employer logo placeholder"
    });
  };

  var hasEmployerLogo = shouldDisplayEmployerLogo(cardStyle, modulesV2);

  if (!hasEmployerLogo && !forceLogo) {
    return useLogoPlaceholder ? renderPlaceholder() : null;
  }

  if (!employer.assets || !employer.assets.brandAssets || !employer.assets.brandAssets.images || !employer.assets.brandAssets.images.logo || !employer.assets.brandAssets.images.logo.variants) {
    return useLogoPlaceholder ? renderPlaceholder() : null;
  }

  var _employer$assets$bran = employer.assets.brandAssets.images.logo.variants,
      desktop = _employer$assets$bran.desktop,
      retina = _employer$assets$bran.retina;

  if (!desktop && !retina) {
    return useLogoPlaceholder ? renderPlaceholder() : null;
  }

  var src = desktop.source;
  var srcSet = retina ? "".concat(retina.source, " 2x") : '';
  var alt = "Logo for ".concat(employer.name);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "__logo")
  }, /*#__PURE__*/React.createElement("img", {
    src: src,
    srcSet: srcSet,
    loading: "lazy",
    width: logoWidth,
    height: logoHeight,
    alt: alt
  }));
};
EmployerLogo.displayName = "EmployerLogo";